import UserService from '@/lib/user'

export default {
    data() {
        return {
            schoolRoles: ['teacher_plus', 'student_plus', 'teacher', 'student'],
            teacherRoles: ['teacher_plus', 'teacher'],
            studentRoles: ['student_plus', 'student'],
            plusRoles: ['teacher_plus', 'student_plus'],
            basicRoles: ['teacher', 'student'],
            teacherPlus: 'teacher_plus',
            studentPlus: 'student_plus',
            teacher: 'teacher',
            student: 'student'
        }
    },
    computed: {
        schoolList() {
            const user = this.getUser()

            if (!user) return []

            return user.schools
        },

        isSchoolRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.schoolRoles.includes(user.role)
        },

        isTeacherRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.teacherRoles.includes(user.role)
        },

        isStudentRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.studentRoles.includes(user.role)
        },

        isPlusRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.plusRoles.includes(user.role)
        },

        isBasicRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.basicRoles.includes(user.role)
        },

        isTeacherPlus() {
            const user = this.getUser()

            if (!user) return false

            return user.role === this.teacherPlus
        },

        isStudentPlus() {
            const user = this.getUser()

            if (!user) return false

            return user.role === this.studentPlus
        },

        isTeacher() {
            const user = this.getUser()

            if (!user) return false

            return user.role === this.teacher
        },

        isStudent() {
            const user = this.getUser()

            if (!user) return false

            return user.role === this.student
        },

        currentSchool() {
            const user = this.getUser()

            if (!user || !user.schools || !user.schools.length) return {}

            return user.schools.find(school => school._id.$oid === user.school_id)
        }
    },

    methods: {
        getUser() {
            return new UserService().getUser()
        },

        getIsStudentRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.studentRoles.includes(user.role)
        },

        getIsSchoolRoles() {
            const user = this.getUser()

            if (!user) return false

            return this.schoolRoles.includes(user.role)
        },

        isSkolerPage() {
            return this.$route.name.indexOf('skoler') > -1 ? true : false
        },

        isSchoolPage() {
            return this.$route.name.indexOf('school') > -1 ? true : false
        }
    }
}
